// extracted by mini-css-extract-plugin
export var circle = "_4f-2";
export var icon = "_4f-a";
export var iconHighlight = "_4f-0";
export var lg = "_4f-8";
export var md = "_4f-7";
export var outline = "_4f-4";
export var sm = "_4f-6";
export var square = "_4f-1";
export var xl = "_4f-9";
export var xs = "_4f-5";
export var xxs = "_4f-3";